// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ExampleCard from "components/card";
// import classNames from 'classnames';

import ApplicationLayout from 'layouts/application_layout';

const Dashboard = () => (
    <ApplicationLayout>
    <Grid container spacing={24} justify="center" alignItems="center">

      <Grid item xs={4}>
        <ExampleCard />
      </Grid>
      <Grid item xs={4}>
        <ExampleCard />
      </Grid>
      <Grid item xs={4}>
        <ExampleCard />
      </Grid>

      <Grid item xs={6}>
        <Paper className="">xs=6</Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper className="">xs=6</Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className="">xs=3</Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className="">xs=3</Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className="">xs=3</Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper className="">xs=3</Paper>
      </Grid>
    </Grid>
    </ApplicationLayout>
 );

export default Dashboard;

// <React.Fragment>
//   <Header />
//   <Main />
//   <Footer />
// </React.Fragment>
